module.exports = __webpack_public_path__ + "img/lines-icon.8b225b04.svg";